// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@vanmeter/XDL/Icons/IconClose";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, styledScrollbar, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 430,
        medium: 656,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 16px 16px 12px;
                align-items: flex-start;
                border-bottom: 0;
            `,
            modalContent: css`
                padding: 0 16px 16px;
                display: flex;
                flex-direction: column;
                gap: 16px;
                ${styledScrollbar()}
            `,
            modalBody: css`
                border-radius: 4px;
                background-color: ${color("common.white")};
                box-shadow: 0 0 0 0.5px ${color("common.border")};
                overflow: hidden;
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
        },
        headlineTypographyProps: {
            variant: "h4",
            css: css`
                margin-bottom: 0;
            `,
        },
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                width: 15px;
                height: 21px;
                & > ${IconWrapper} {
                    color: ${color("common.ui5")};
                }
                &:not(:disabled):hover,
                &:not(:disabled):focus {
                    > ${IconWrapper} {
                        color: ${color("common.ui15")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            color: "common.ui5",
            width: 15,
            height: 21,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
